var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-stack h-stretch gap-3"},[_c('TableGear',{on:{"rowSelected":function($event){return _vm.$router.push('/pricelist/item/detail/' + $event._id)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }